import {
  Contract,
  ServiceCategoryType
} from "@/components/Contracts/contract.interface";
import { OperationType } from "@/modules/Settings/pages/Operations/enum";

export const shouldHaveOwnershipTransfer = (currentContract: Contract) => {
  const isBringYourOwn = currentContract?.items?.every(
    item => item?.operation?.type === OperationType.BRING_YOUR_OWN
  );

  const implementedCarriers = ["TIM"];

  const hasImplementedCarrier = currentContract.items.some(item =>
    implementedCarriers.includes(item?.offerPrice?.offer?.plan?.carrier?.name)
  );

  const isMobileLine =
    currentContract.serviceCategory.type === ServiceCategoryType.MOBILE_LINE;

  return isBringYourOwn && hasImplementedCarrier && isMobileLine;
};
